// @ts-check

/**
 * @param {import('../').EquinoxProductVariantProperties} properties 
 */
function mapVariantProperties(properties = {}) {
  /** @type {import('../').EquinoxProductVariantProperties} */
  const model = {};
  model.benefits = mapBenefits(properties.benefits);
  model.excludeFromSearch = mapExcludeFromSearch(properties.excludeFromSearch);
  model.usage = mapUsage(properties.usage);
  model.description = mapDescription(properties.description);
  model.chargeShipping = mapChargeShipping(properties.chargeShipping);
  model.globalProductId = mapGlobalProductId(properties.globalProductId);
  model.title = mapTitle(properties.title);
  model.scanQualifiedCount = mapScanQualifiedCount(properties.scanQualifiedCount);
  model.division = mapDivision(properties.division);
  model.isExclusive = mapIsExclusive('false',);
  model.imageURL = mapImageURL(properties.imageURL);
  model.customerTypes = mapCustomerTypes(properties.customerTypes);
  model.ingredients = mapIngredients(properties.ingredients);
  model.availableChannels = mapAvailableChannels(properties.availableChannels);
  model.resources = mapResources(properties.resources);
  model.market = mapMarket(properties.market);
  model.size = mapSize(properties.size);
  model.name = mapName(properties.name);
  model.status = mapStatus(properties.status);
  model.productStatus = mapProductStatus(properties.productStatus);

  return model;
}

/**
 * @param {string|undefined} benefits
 * @returns {string}
 */
function mapBenefits(benefits) {
  if (benefits) {
    return benefits;
  }

  return '';
}

/**
 * @param {string|undefined} excludeFromSearch
 * @returns {string}
 */
function mapExcludeFromSearch(excludeFromSearch) {
  if (excludeFromSearch) {
    return excludeFromSearch;
  }

  return '';
}

/**
 * @param {string|undefined} usage
 * @returns {string}
 */
function mapUsage(usage) {
  if (usage) {
    return usage;
  }

  return '';
}

/**
 * @param {string|undefined} description
 * @returns {string}
 */
function mapDescription(description) {
  if (description) {
    return description;
  }

  return '';
}

/**
 * @param {string|undefined} chargeShipping
 * @returns {string}
 */
function mapChargeShipping(chargeShipping) {
  if (chargeShipping) {
    return chargeShipping;
  }

  return '';
}

/**
 * @param {string|undefined} globalProductId
 * @returns {string}
 */
function mapGlobalProductId(globalProductId) {
  if (globalProductId) {
    return globalProductId;
  }

  return '';
}

/**
 * @param {string|undefined} title
 * @returns {string}
 */
function mapTitle(title) {
  if (title) {
    return title;
  }

  return '';
}

/**
 * @param {string|undefined} scanQualifiedCount
 * @returns {string}
 */
function mapScanQualifiedCount(scanQualifiedCount) {
  if (scanQualifiedCount) {
    return scanQualifiedCount;
  }

  return '';
}

/**
 * @param {string|undefined} division
 * @returns {string}
 */
function mapDivision(division) {
  if (division) {
    return division;
  }

  return '';
}

/**
 * @param {string|undefined} isExclusive
 * @returns {string}
 */
function mapIsExclusive(isExclusive) {
  if (isExclusive) {
    return isExclusive;
  }

  return '';
}

/**
 * @param {string|undefined} imageURL
 * @returns {string}
 */
function mapImageURL(imageURL) {
  if (imageURL) {
    return imageURL;
  }

  return '';
}

/**
 * @param {string|undefined} customerTypes
 * @returns {string}
 */
function mapCustomerTypes(customerTypes) {
  if (customerTypes) {
    return customerTypes;
  }

  return '';
}

/**
 * @param {string|undefined} ingredients
 * @returns {string}
 */
function mapIngredients(ingredients) {
  if (ingredients) {
    return ingredients;
  }

  return '';
}

/**
 * @param {string|undefined} availableChannels
 * @returns {string}
 */
function mapAvailableChannels(availableChannels) {
  if (availableChannels) {
    return availableChannels;
  }

  return '';
}

/**
 * @param {string|undefined} resources
 * @returns {string}
 */
function mapResources(resources) {
  if (resources) {
    return resources;
  }

  return '';
}

/**
 * @param {string|undefined} market
 * @returns {string}
 */
function mapMarket(market) {
  if (market) {
    return market;
  }

  return '';
}

/**
 * @param {string|undefined} size
 * @returns {string}
 */
function mapSize(size) {
  if (size) {
    return size;
  }

  return '';
}

/**
 * @param {string|undefined} name
 * @returns {string}
 */
function mapName(name) {
  if (name) {
    return name;
  }

  return '';
}

/**
 * @param {string|undefined} status
 * @returns {string}
 */
function mapStatus(status) {
  if (status) {
    return status;
  }

  return '';
}

/**
 * @param {string|undefined} productStatus
 * @returns {string}
 */
function mapProductStatus(productStatus) {
  if (productStatus) {
    return productStatus;
  }

  return '';
}

module.exports = mapVariantProperties;
